
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './AboutUs.css';
import OurValues from './Images/OurValues_1.jpg';
import OurVision from './Images/OurVision_1.jpg';
import OurMission from './Images/OurMission_1.jpg';
import { Helmet } from "react-helmet-async";
import img9 from "./Images/A.pTechNewLogo_3.png";
import img3 from "./Images/A.pTechNewLogo_3.png";
import { Link } from 'react-router-dom';
import TeamSection from './TeamSection';
import { FiCheckCircle } from "react-icons/fi"; // Blue check icon



const ApiProductList = () => {

    const location = useLocation();
    const missionRef = useRef(null);
    const leadershipRef = useRef(null);

    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target === 'mission' && missionRef.current) {
            missionRef.current.scrollIntoView({ behavior: 'smooth' });
        } else if (target === 'leadership' && leadershipRef.current) {
            leadershipRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);


    return (
        <div>

<Helmet>
  <title>About Us | IT Services Company in Ankleshwar</title>
  <meta 
    name="description" 
    content="APTech Solution is a trusted IT services provider in Ankleshwar, Gujarat. We specialize in web development, mobile apps, Salesforce, and digital transformation." 
  />
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "APTech Solution",
        "url": "https://aptechsolution.com",
        "logo": "https://aptechsolution.com/logo.png",
        "sameAs": [
          "https://www.facebook.com/aptechsolution",
          "https://www.linkedin.com/company/aptechsolution"
        ]
      }
    `}
  </script>
</Helmet>


         <div className='fullcolordiv'>
                <h2 className='aboutpageheading'> About A.P Tech Solution (APTS) </h2>
                <p className='aboutpageparagraph'>A.P Tech Solution (APTS) is a technology partner for businesses, building scalable and user-friendly software solutions that empower growth in the digital era.</p>
         </div>




            <div className="company-container">
                <div className="company-text">
                    <h2>Our Company</h2>
                    <p>
                        Welcome to <strong>A.P Tech Solution</strong>, your reliable partner in digital innovation. We specialize in building
                        scalable, secure, and intelligent software solutions that transform ideas into high-performing products. Our team works with businesses of all sizes — from startups to enterprises — delivering technology that powers growth.
                    </p>
                    <p>
                        At A.P Tech Solution, we combine deep technical expertise with industry insight to deliver tailored solutions for every
                        challenge. Whether it's building mobile apps, enterprise platforms, or interactive websites, our focus is always on quality,
                        performance, and user experience.
                    </p>
                   

                    {/* ✅ Certifications with blue icons */}
                    <div className="company-certifications">
                        <ul>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Custom Software Solutions for All Industries
                            </li>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Ongoing Maintenance & Post-launch Support
                            </li>
                        </ul>
                        <ul>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Cloud-Native, Scalable Architecture
                            </li>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Cross-Platform Mobile App Expertise
                            </li>
                        </ul>
                    </div>
                </div>

                {/* 🔄 Image Slider */}
                <div className="company-image">
                    <div className="slide-track">
                        <img src={img3} alt="Company 1" className="slide" />
                        <img src={img9} alt="Company 2" className="slide" />
                    </div>
                </div>
            </div>
            <div className='MissionVisionValues' ref={missionRef} id="mission">
            <div className='OurMissionCenter'>
                <h3 className='OurMissionHeading'> Our Mission & Vision & Values</h3>
                    <p className='urMissionParagraph'>Driving Innovation and Excellence in Global Chemical Solutions</p>
            </div>

            <div className='mission'>
                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                            <img src={OurMission} alt='logo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Mission</h3>
                            <p className="pp">
                                    To empower businesses through cutting-edge digital solutions that drive sustainable growth, streamline operations, and elevate user engagement. We are committed to building impactful software that solves real-world challenges and delivers measurable results.


                            </p>
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                                <img src={OurValues} alt='homelogo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Vision</h3>
                            <p className="pp">
                                    To become a globally recognized technology partner, known for transforming ideas into intelligent digital systems. We strive to create innovative, scalable, and secure solutions that fuel business success and long-term value across industries.</p>
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                                <img src={OurVision} alt='jome logo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Values</h3>
                            <p className="pp">
                                    We are driven by innovation, guided by integrity, and built on collaboration. We believe in continuous learning, transparent communication, and delivering excellence in every solution we craft. Our client-first mindset ensures we build not just software — but trust, partnerships, and growth.


                            </p>
                        </div>
                    </div>
                </div>
            </div>
         </div>
             

            <div ref={leadershipRef} id="leadership" >
                <TeamSection />
            </div>


            <div className='fullcolordiv1'>
                <h2 className='aboutpageheading'>Ready to Work With Us? </h2>
                <p className='aboutpageparagraph'>Contact us today to discuss how our products and services can benefit your business.</p>
                <Link to="/contact" state={{ scrollTo: "form" }}>
                <button className="aboutpage-button">Contact Us Now</button>
            </Link>
            </div>


        </div>
    );
};

export default ApiProductList;
